const formatting = 
{
    header:{  fontWeight: '300',color:'#163667', fontSize: '16px', paddingTop: '5px', paddingBottom: '5px',whiteSpace:'pre-line' }

}

export default formatting;